/**
 * Derives the thumbnail URL from a storage path.
 * Thumbnails are stored in a /thumbnails/ subdirectory within the same folder.
 *
 * Example:
 *   Input:  storage/abc123/photo.jpg
 *   Output: storage/abc123/thumbnails/photo.jpg
 */
export function getThumbnailUrl(storagePath: string): string {
  const lastSlashIndex = storagePath.lastIndexOf("/");
  if (lastSlashIndex === -1) {
    // No directory in path, return as-is
    return storagePath;
  }

  const directory = storagePath.substring(0, lastSlashIndex);
  const filename = storagePath.substring(lastSlashIndex + 1);

  return `${directory}/thumbnails/${filename}`;
}
